export const referralNoRowsTemplate = msg => {
  return `
<div>
      <svg width="54" height="55" viewBox="0 0 54 55" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="27" cy="27.5" r="20.2584" stroke="#CFCFCF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M36.0037 36.5037C35.742 35.8451 35.3359 35.2536 34.8152 34.7728V34.7728C33.938 33.9574 32.785 33.5039 31.5874 33.5033H22.4148C21.2166 33.504 20.0628 33.9575 19.1847 34.7728V34.7728C18.6653 35.2547 18.2594 35.8459 17.9962 36.5037" stroke="#CFCFCF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<ellipse cx="27" cy="23.5609" rx="5.06461" ry="5.06461" stroke="#CFCFCF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    <p class="font-Regular-14" style="color:#BBBBBB;">${msg}</p>
    </div>`;
};
